import React from 'react'
import ImgUtil from '../../../utils/img.utils'
import Typography from '../typography'
import WrapperImage from '../wrapperImage'
import { ModuleNames } from '../../../constants/componentNames.constants'
import { NavLinks, ResponsiveIcon, SubLinks } from './style'
import { LanguageSelect } from '../../../constants/localization.constants'

type NavLogoProps = {
  imgSrc: string,
  imgUrl: string,
  altText: string
}

type NavIconProps = {
  openMenu: boolean,
  setOpenMenu: (prop: boolean) => void
}

type NavItemProps = {
  id: number,
  url: string,
  text: string,
  className: string
}

const uiPathURL = LanguageSelect.rows[0].href + "/"

const handleAccordionOpen = (event: any) => {
  const current = event.currentTarget
  const parent = event.currentTarget.parentElement

  if (current.classList.contains('is-active')) {
    current.classList.remove('is-active')
    parent.classList.remove('CustomHeader__Dropdown')
  } else {
    current.classList.add('is-active')
    parent.classList.add('CustomHeader__Dropdown')
  }
}

export const NavLogo = ({ imgSrc, imgUrl, altText}: NavLogoProps) => (
  <a href={imgSrc}>
    <WrapperImage
      className="CustomHeader__Logo"
      src={ImgUtil.getResizedImageUrl(imgUrl, '')}
      width={136}
      alt={altText}
    />
  </a>
)

export const NavIcon = ({ openMenu, setOpenMenu }: NavIconProps) => (
  <ResponsiveIcon openMenu={openMenu} onClick={() => setOpenMenu(!openMenu)}>
    <Typography type="captionAlt" className='CustomHeader__Close'>
      Close
    </Typography>
    <div className="CustomHeader__Hamburger">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </ResponsiveIcon>
)

export const LinkItem = ({ id, url, text, className }: NavItemProps) => (
  <li key={id} className={className}>
    <a href={url}>
      <Typography type={'label'}>{ text }</Typography>
    </a>
  </li>
)

export const NavSubLinksMenu = ({ newGroupName, subLinks }: any) => (
  <div>
    <button className='CustomHeader__Mobile_Button Menu-item js-Menu-item' onClick={handleAccordionOpen}>
      <Typography type={'label'}>
        { newGroupName }
      </Typography>
    </button>
    
    <SubLinks className='CustomHeader__Sublinks'>
      { subLinks.map((subLink: any) => (
        <LinkItem 
          id={subLink?.id} 
          url={subLink?.externalUrl} 
          text={subLink?.text} 
          className={'CustomHeader__Sublink'} 
        />
      )) }
    </SubLinks>
  </div>
)

export const NavLinksMenu = ({ navLinks, openMenu }: any) => (
  <NavLinks openMenu={openMenu}>
    { navLinks?.map((navLink: any) => {
      const { ctaText, text, internalLink, newGroupName, parentLink, externalUrl } = navLink
      const internalLinkName = ctaText || internalLink?.pageName || internalLink?.name
      const isListMenu = navLink?.groupStyle === 'List'

      const parentLinkSlugUrl = parentLink?.internalLink?.slug && (uiPathURL + parentLink.internalLink.slug)
      const menuGroupSrc = parentLink?.externalUrl || parentLinkSlugUrl || "#"
      const internalLinkSrc = internalLink?.slug && (uiPathURL + internalLink.slug)
      const topicCtaSrc = externalUrl || internalLinkSrc || "#"

      switch (navLink.__typename) {
        case ModuleNames.TOPIC_CTA:
          return (
            <LinkItem 
              id={navLink?.id} 
              url={topicCtaSrc} 
              text={text} 
              className={'CustomHeader__NavLink'} 
            />
          )

        case ModuleNames.TOPIC_INTERNAL_LINK:
          return (
            <LinkItem 
              id={navLink?.id} 
              url={internalLinkSrc} 
              text={internalLinkName} 
              className={'CustomHeader__NavLink'} 
            />
          )

        case ModuleNames.MENU_GROUP:
          return (
            <div className='CustomHeader__MenuGroup'>
              <li key={navLink?.id} className={`CustomHeader__NavLink ${isListMenu ? 'NavLink_List' : ''}`}>
                <a href={menuGroupSrc}>
                  <Typography type={'label'}>
                    { newGroupName }
                  </Typography>
                </a>
              </li>

              { isListMenu && (
                <NavSubLinksMenu newGroupName={newGroupName} subLinks={navLink?.pages} />) 
              }
            </div>
          )
      }
    })}
  </NavLinks>
)

